import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { API_URL } from '../config';

const TEXT = {
  es: {
    title: 'Meta Ads (Facebook e Instagram)',
    description: 'Conecta tu cuenta publicitaria para que el gasto en anuncios se a\u00f1ada solo a tu ganancia real. Solo lectura: la app nunca crea ni cambia anuncios.',
    tokenToggle: '\u00bfProblemas al conectar? Usar un token (avanzado)',
    tokenHint: 'Genera un token en el Explorador de la API Graph de Meta, eligiendo la app Flash Multiservice y el permiso ads_read, y p\u00e9galo aqu\u00ed. La app lo convierte en una conexi\u00f3n de 60 d\u00edas.',
    tokenConnect: 'Conectar con el token',
    connect: 'Conectar Meta Ads',
    connecting: 'Abriendo Facebook...',
    connectedAs: 'Conectado como',
    account: 'Cuenta publicitaria',
    chooseAccount: 'Elige una cuenta',
    inactive: 'inactiva',
    channel: 'Canal al que asignar el gasto',
    channelHint: 'Por ejemplo, Shopify si tus anuncios llevan a tu tienda Shopify, o General si no son de un canal concreto.',
    save: 'Guardar y sincronizar',
    saving: 'Guardando...',
    cancel: 'Cancelar',
    lastSync: '\u00daltima sincronizaci\u00f3n',
    every6h: 'Se sincroniza autom\u00e1ticamente cada 6 horas.',
    syncNow: 'Sincronizar ahora',
    syncing: 'Sincronizando...',
    changeAccount: 'Cambiar cuenta o canal',
    disconnect: 'Desconectar',
    reconnect: 'Volver a conectar',
    confirmDisconnect: '\u00bfDesconectar Meta Ads? El gasto ya importado se conserva y podr\u00e1s editarlo a mano.',
    expiresSoon: 'La conexi\u00f3n con Meta caduca el {{date}}. Vuelve a conectar para que no se interrumpa la sincronizaci\u00f3n.',
    connectedMsg: 'Meta Ads conectado.',
    cancelledMsg: 'Has cancelado la conexi\u00f3n con Meta.',
    errorMsg: 'No se pudo conectar con Meta. Int\u00e9ntalo de nuevo.',
    saved: 'Cuenta guardada y gasto sincronizado.',
    synced: 'Gasto sincronizado.',
    noAccounts: 'Tu usuario de Facebook no tiene cuentas publicitarias disponibles.',
    loading: 'Cargando...',
    genericError: 'No se pudo completar la operaci\u00f3n.',
  },
  en: {
    title: 'Meta Ads (Facebook and Instagram)',
    description: 'Connect your ad account so your ad spend is added to your real profit automatically. Read only: the app never creates or changes ads.',
    tokenToggle: 'Trouble connecting? Use a token (advanced)',
    tokenHint: 'Generate a token in Meta\u2019s Graph API Explorer, choosing the Flash Multiservice app and the ads_read permission, and paste it here. The app turns it into a 60-day connection.',
    tokenConnect: 'Connect with token',
    connect: 'Connect Meta Ads',
    connecting: 'Opening Facebook...',
    connectedAs: 'Connected as',
    account: 'Ad account',
    chooseAccount: 'Choose an account',
    inactive: 'inactive',
    channel: 'Channel to assign the spend to',
    channelHint: 'For example, Shopify if your ads lead to your Shopify store, or General if they are not tied to one channel.',
    save: 'Save and sync',
    saving: 'Saving...',
    cancel: 'Cancel',
    lastSync: 'Last sync',
    every6h: 'Syncs automatically every 6 hours.',
    syncNow: 'Sync now',
    syncing: 'Syncing...',
    changeAccount: 'Change account or channel',
    disconnect: 'Disconnect',
    reconnect: 'Reconnect',
    confirmDisconnect: 'Disconnect Meta Ads? The spend already imported is kept and you will be able to edit it by hand.',
    expiresSoon: 'The Meta connection expires on {{date}}. Reconnect so syncing is not interrupted.',
    connectedMsg: 'Meta Ads connected.',
    cancelledMsg: 'You cancelled the Meta connection.',
    errorMsg: 'Could not connect to Meta. Please try again.',
    saved: 'Account saved and spend synced.',
    synced: 'Spend synced.',
    noAccounts: 'Your Facebook user has no ad accounts available.',
    loading: 'Loading...',
    genericError: 'The operation could not be completed.',
  },
  fr: {
    title: 'Meta Ads (Facebook et Instagram)',
    description: 'Connectez votre compte publicitaire pour que vos d\u00e9penses publicitaires s\u2019ajoutent automatiquement \u00e0 votre b\u00e9n\u00e9fice r\u00e9el. Lecture seule : l\u2019application ne cr\u00e9e ni ne modifie jamais de publicit\u00e9s.',
    tokenToggle: 'Probl\u00e8me de connexion ? Utiliser un jeton (avanc\u00e9)',
    tokenHint: 'G\u00e9n\u00e9rez un jeton dans l\u2019Explorateur de l\u2019API Graph de Meta, en choisissant l\u2019application Flash Multiservice et l\u2019autorisation ads_read, puis collez-le ici. L\u2019application le transforme en connexion de 60 jours.',
    tokenConnect: 'Connecter avec le jeton',
    connect: 'Connecter Meta Ads',
    connecting: 'Ouverture de Facebook...',
    connectedAs: 'Connect\u00e9 en tant que',
    account: 'Compte publicitaire',
    chooseAccount: 'Choisissez un compte',
    inactive: 'inactif',
    channel: 'Canal auquel attribuer la d\u00e9pense',
    channelHint: 'Par exemple Shopify si vos publicit\u00e9s m\u00e8nent \u00e0 votre boutique Shopify, ou General si elles ne concernent pas un canal pr\u00e9cis.',
    save: 'Enregistrer et synchroniser',
    saving: 'Enregistrement...',
    cancel: 'Annuler',
    lastSync: 'Derni\u00e8re synchronisation',
    every6h: 'Synchronisation automatique toutes les 6 heures.',
    syncNow: 'Synchroniser maintenant',
    syncing: 'Synchronisation...',
    changeAccount: 'Changer de compte ou de canal',
    disconnect: 'D\u00e9connecter',
    reconnect: 'Reconnecter',
    confirmDisconnect: 'D\u00e9connecter Meta Ads ? Les d\u00e9penses d\u00e9j\u00e0 import\u00e9es sont conserv\u00e9es et vous pourrez les modifier \u00e0 la main.',
    expiresSoon: 'La connexion \u00e0 Meta expire le {{date}}. Reconnectez-vous pour ne pas interrompre la synchronisation.',
    connectedMsg: 'Meta Ads connect\u00e9.',
    cancelledMsg: 'Vous avez annul\u00e9 la connexion \u00e0 Meta.',
    errorMsg: 'Impossible de se connecter \u00e0 Meta. R\u00e9essayez.',
    saved: 'Compte enregistr\u00e9 et d\u00e9penses synchronis\u00e9es.',
    synced: 'D\u00e9penses synchronis\u00e9es.',
    noAccounts: 'Votre utilisateur Facebook n\u2019a aucun compte publicitaire disponible.',
    loading: 'Chargement...',
    genericError: 'L\u2019op\u00e9ration n\u2019a pas pu aboutir.',
  },
};

const CHANNEL_SUGGESTIONS = ['General', 'Shopify', 'WooCommerce', 'TikTok', 'Instagram', 'WhatsApp'];
const getText = (lang) => TEXT[(lang || 'es').slice(0, 2)] || TEXT.es;

function MetaAdsCard({ token, onAuthError }) {
  const { i18n } = useTranslation();
  const tx = getText(i18n.language);
  const headers = { headers: { Authorization: `Bearer ${token}` } };
  const [status, setStatus] = useState(null);
  const [accounts, setAccounts] = useState(null);
  const [choice, setChoice] = useState({ account: '', channel: 'General' });
  const [editing, setEditing] = useState(false);
  const [busy, setBusy] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [showToken, setShowToken] = useState(false);
  const [manualToken, setManualToken] = useState('');

  const fail = (err) => {
    if (err.response && err.response.status === 401) {
      onAuthError();
      return;
    }
    const detail = err.response && err.response.data && err.response.data.detail;
    setIsError(true);
    setMessage(typeof detail === 'string' ? detail : tx.genericError);
  };

  const loadStatus = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/v1/integrations/meta`, headers);
      setStatus(response.data.data);
      return response.data.data;
    } catch (err) {
      fail(err);
      return null;
    }
  };

  const loadAccounts = async () => {
    setBusy('accounts');
    try {
      const response = await axios.get(`${API_URL}/api/v1/integrations/meta/ad-accounts`, headers);
      setAccounts(response.data.data || []);
    } catch (err) {
      fail(err);
    } finally {
      setBusy('');
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const result = params.get('meta');
    if (result) {
      setIsError(result !== 'connected');
      setMessage(result === 'connected' ? tx.connectedMsg : result === 'cancelled' ? tx.cancelledMsg : tx.errorMsg);
      params.delete('meta');
      const rest = params.toString();
      window.history.replaceState(null, '', window.location.pathname + (rest ? `?${rest}` : ''));
    }
    loadStatus().then((s) => {
      if (s && s.connected && !s.ad_account_id) loadAccounts();
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const connect = async () => {
    setBusy('connect');
    try {
      const response = await axios.get(`${API_URL}/api/v1/integrations/meta/authorize`, headers);
      window.location.href = response.data.url;
    } catch (err) {
      fail(err);
      setBusy('');
    }
  };

  const connectWithToken = async () => {
    if (!manualToken.trim()) return;
    setBusy('token');
    setMessage('');
    try {
      await axios.post(`${API_URL}/api/v1/integrations/meta/token`, { access_token: manualToken.trim() }, headers);
      setManualToken('');
      setShowToken(false);
      setIsError(false);
      setMessage(tx.connectedMsg);
      const s = await loadStatus();
      if (s && s.connected && !s.ad_account_id) loadAccounts();
    } catch (err) {
      fail(err);
    } finally {
      setBusy('');
    }
  };

  const save = async () => {
    if (!choice.account || !choice.channel.trim()) return;
    setBusy('save');
    setMessage('');
    try {
      const response = await axios.put(
        `${API_URL}/api/v1/integrations/meta`,
        { ad_account_id: choice.account, channel: choice.channel.trim() },
        headers
      );
      const sync = response.data.sync || {};
      setIsError(sync.status === 'error');
      setMessage(sync.status === 'error' ? sync.error : tx.saved);
      setEditing(false);
      await loadStatus();
    } catch (err) {
      fail(err);
    } finally {
      setBusy('');
    }
  };

  const syncNow = async () => {
    setBusy('sync');
    setMessage('');
    try {
      await axios.post(`${API_URL}/api/v1/integrations/meta/sync`, {}, headers);
      setIsError(false);
      setMessage(tx.synced);
    } catch (err) {
      fail(err);
    } finally {
      await loadStatus();
      setBusy('');
    }
  };

  const disconnect = async () => {
    if (!window.confirm(tx.confirmDisconnect)) return;
    setBusy('disconnect');
    try {
      await axios.delete(`${API_URL}/api/v1/integrations/meta`, headers);
      setAccounts(null);
      setEditing(false);
      setMessage('');
      await loadStatus();
    } catch (err) {
      fail(err);
    } finally {
      setBusy('');
    }
  };

  const startEditing = () => {
    setEditing(true);
    setChoice({ account: status.ad_account_id || '', channel: status.channel_label || 'General' });
    loadAccounts();
  };

  if (!status || !status.configured) return null;

  const showPicker = status.connected && (!status.ad_account_id || editing);
  const expiresSoon = status.token_expires_at && new Date(status.token_expires_at) - Date.now() < 7 * 24 * 3600 * 1000;
  const formatDate = (value) => (value ? new Date(value).toLocaleString(i18n.language) : '\u2014');
  const input = 'w-full bg-surfaceAlt border border-edge rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-accent';
  const secondary = 'bg-transparent border border-edge text-white text-sm px-4 py-2 rounded-lg cursor-pointer';

  return (
    <div className="bg-surface border border-edge rounded-2xl p-5 sm:p-6 max-w-lg mb-6">
      <p className="text-white text-sm font-semibold mb-1">{tx.title}</p>
      <p className="text-muted text-xs mb-4">{tx.description}</p>

      {!status.connected && (
        <div className="flex flex-col gap-3">
          <button type="button" onClick={connect} disabled={!!busy} className="self-start bg-accent text-panel font-bold text-sm px-5 py-2 rounded-lg cursor-pointer">
            {busy === 'connect' ? tx.connecting : tx.connect}
          </button>
          <button type="button" onClick={() => setShowToken((v) => !v)} className="self-start text-muted text-xs underline cursor-pointer">
            {tx.tokenToggle}
          </button>
          {showToken && (
            <div className="flex flex-col gap-2 bg-surfaceAlt border border-edge rounded-lg p-3">
              <p className="text-muted text-xs">{tx.tokenHint}</p>
              <textarea
                rows={3}
                value={manualToken}
                onChange={(e) => setManualToken(e.target.value)}
                placeholder="EAA..."
                className={input}
              />
              <button
                type="button"
                onClick={connectWithToken}
                disabled={!!busy || !manualToken.trim()}
                className="self-start bg-accent text-panel font-bold text-sm px-5 py-2 rounded-lg cursor-pointer"
              >
                {busy === 'token' ? tx.saving : tx.tokenConnect}
              </button>
            </div>
          )}
        </div>
      )}

      {status.connected && (
        <div className="flex flex-col gap-3">
          <p className="text-muted text-xs">
            {tx.connectedAs} <span className="text-white">{status.fb_user_name || '\u2014'}</span>
          </p>
          {expiresSoon && (
            <div className="bg-[#2a1f0f] border border-[#7f5f1d] rounded-lg p-3">
              <p className="text-amber-400 text-xs mb-2">{tx.expiresSoon.replace('{{date}}', formatDate(status.token_expires_at))}</p>
              <button type="button" onClick={connect} disabled={!!busy} className={secondary}>{tx.reconnect}</button>
            </div>
          )}
          {status.last_sync_error && (
            <div className="bg-[#2a0f0f] border border-[#7f1d1d] rounded-lg p-3">
              <p className="text-red-400 text-xs mb-2">{status.last_sync_error}</p>
              <button type="button" onClick={connect} disabled={!!busy} className={secondary}>{tx.reconnect}</button>
            </div>
          )}

          {showPicker ? (
            accounts === null ? (
              <p className="text-muted text-sm">{tx.loading}</p>
            ) : accounts.length === 0 ? (
              <p className="text-amber-400 text-sm">{tx.noAccounts}</p>
            ) : (
              <div className="flex flex-col gap-3">
                <div>
                  <label className="text-muted text-xs block mb-1.5">{tx.account}</label>
                  <select value={choice.account} onChange={(e) => setChoice((v) => ({ ...v, account: e.target.value }))} className={input}>
                    <option value="">{tx.chooseAccount}</option>
                    {accounts.map((a) => (
                      <option key={a.id} value={a.id}>
                        {a.name} ({a.currency}){a.active ? '' : ` \u00b7 ${tx.inactive}`}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="text-muted text-xs block mb-1.5">{tx.channel}</label>
                  <input
                    type="text"
                    list="meta-channel-suggestions"
                    value={choice.channel}
                    onChange={(e) => setChoice((v) => ({ ...v, channel: e.target.value }))}
                    className={input}
                  />
                  <datalist id="meta-channel-suggestions">
                    {CHANNEL_SUGGESTIONS.map((c) => (
                      <option key={c} value={c} />
                    ))}
                  </datalist>
                  <p className="text-muted text-xs mt-1.5">{tx.channelHint}</p>
                </div>
                <div className="flex flex-wrap gap-2">
                  <button type="button" onClick={save} disabled={!!busy || !choice.account} className="bg-accent text-panel font-bold text-sm px-5 py-2 rounded-lg cursor-pointer">
                    {busy === 'save' ? tx.saving : tx.save}
                  </button>
                  {editing && (
                    <button type="button" onClick={() => setEditing(false)} className={secondary}>{tx.cancel}</button>
                  )}
                </div>
              </div>
            )
          ) : (
            <div className="flex flex-col gap-3">
              <div className="bg-surfaceAlt border border-edge rounded-lg p-3">
                <p className="text-muted text-xs">{tx.account}</p>
                <p className="text-white text-sm">{status.ad_account_name} ({status.currency})</p>
                <p className="text-muted text-xs mt-2">{tx.channel}</p>
                <p className="text-white text-sm">{status.channel_label}</p>
                <p className="text-muted text-xs mt-2">{tx.lastSync}: <span className="text-white">{formatDate(status.last_synced_at)}</span></p>
                <p className="text-muted text-xs mt-1">{tx.every6h}</p>
              </div>
              <div className="flex flex-wrap gap-2">
                <button type="button" onClick={syncNow} disabled={!!busy} className="bg-accent text-panel font-bold text-sm px-5 py-2 rounded-lg cursor-pointer">
                  {busy === 'sync' ? tx.syncing : tx.syncNow}
                </button>
                <button type="button" onClick={startEditing} disabled={!!busy} className={secondary}>{tx.changeAccount}</button>
                <button type="button" onClick={disconnect} disabled={!!busy} className="text-red-400 text-sm px-4 py-2 rounded-lg border border-[#7f1d1d] cursor-pointer">
                  {tx.disconnect}
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {message && <p className={`text-xs mt-3 ${isError ? 'text-red-400' : 'text-accent'}`}>{message}</p>}
    </div>
  );
}

export default MetaAdsCard;